export default __webpack_public_path__ + "static/media/checkBox.1ab8f0b6.svg";